<template>
  <div class="kpt-configurator-accessories">
    <header class="p-4 is-flex is-justify-content-space-between is-align-items-center">
      <h1 class="mb-0">u8 Accessories</h1>
      <b-button
        rounded
        size="is-small"
        type="is-dark"
        @click="$store.commit('configurator/setActivePage', 2);">
        BACK TO CART
      </b-button>
    </header>
    <main class="accessory-selector-wrapper">
      <aside class="accessory-selector-filters px-4">
        <div class="menu">
          <p class="menu-label">Product Type</p>
          <ul class="menu-list">
            <li><a @click="toggleFilter('productFamily', 'accessories')"><span class="is-unselectable" :class="filterActive({ productFamily: 'accessories' }) ? 'has-text-weight-semibold' : ''">Accessory</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ productFamily: 'accessories' }) ? 'check-square' : 'square'"></b-icon></a> </li>
            <li><a @click="toggleFilter('productFamily', 'cables')"><span class="is-unselectable" :class="filterActive({ productFamily: 'cables' }) ? 'has-text-weight-semibold' : ''">Cable</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ productFamily: 'cables' }) ? 'check-square' : 'square'"></b-icon></a> </li>
            <li><a @click="toggleFilter('productFamily', 'components')"><span class="is-unselectable" :class="filterActive({ productFamily: 'components' }) ? 'has-text-weight-semibold' : ''">FRUs</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ productFamily: 'components' }) ? 'check-square' : 'square'"></b-icon></a> </li>
          </ul>
          <p class="menu-label">Target Audience</p>
          <ul class="menu-list">
            <li><a @click="toggleFilter('comm', true)"><span class="is-unselectable" :class="filterActive({ comm: true }) ? 'has-text-weight-semibold' : ''">Commercial</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ comm: true }) ? 'check-square' : 'square'"></b-icon></a> </li>
            <!-- <li><a @click="toggleFilter('mil', true)"><span class="is-unselectable" :class="filterActive({ mil: true }) ? 'has-text-weight-semibold' : ''">Military</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ mil: true }) ? 'check-square' : 'square'"></b-icon></a> </li> -->
          </ul>
          <p class="menu-label">Availability</p>
          <ul class="menu-list">
            <li><a @click="toggleFilter('unavailable', false)"><span class="is-unselectable" :class="filterActive({ unavailable: false }) ? 'has-text-weight-semibold' : ''">Available</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ unavailable: false }) ? 'check-square' : 'square'"></b-icon></a> </li>
            <li><a @click="toggleFilter('unavailable', true)"><span class="is-unselectable" :class="filterActive({ unavailable: true }) ? 'has-text-weight-semibold' : ''">Coming Soon</span> <b-icon class="is-pulled-left mr-1" :icon="filterActive({ unavailable: true }) ? 'check-square' : 'square'"></b-icon></a> </li>
          </ul>
        </div>
      </aside>
      <div>
        <div class="accessory-selector-items px-4">
          <div class="accessory-item p-4" v-for="accessory in filteredAccessories" :key="accessory.kpc" @mouseover="mouseOverVisibleOn = accessory.id" @mouseleave="mouseOverVisibleOn = null">
            <div class="accessory-item-image">
              <b-image v-if="!accessory.assets" :src="require(`@/assets/configurator/placeholder.png`)" @click.native="openProductDetail(accessory)"></b-image>
              <b-image v-else :src="`${assetCdnUrl}/${accessory.assets[0]}`" @click.native="openProductDetail(accessory)"></b-image>
              <div class="accessory-item-more-info buttons is-right" v-show="mouseOverVisibleOn == accessory.id">
                <b-button rounded size="is-small" type="is-primary is-outlined" @click="openProductDetail(accessory)">
                  More Info
                </b-button>
              </div>
            </div>
            <div class="accessory-item-content">
              <h6 class="has-text-black-ter has-text-weight-semibold mb-0">{{accessory.name}}</h6>
              <p class="is-size-7 is-uppercase mt-0">{{accessory.productFamily}}</p>
              <template v-if="showPrices">
                <div class="my-2" v-if="wholesale">
                  <p><span class="is-size-7 is-uppercase">Wholesale:</span> <span class="has-text-weight-semibold">{{ accessory.wholesalePrice ? $numeral(accessory.wholesalePrice).format('$0,0') : 'N/A' }}</span></p>
                  <p><span class="is-size-7 is-uppercase">MSRP:</span> <span class="has-text-weight-semibold">{{ accessory.msrpPrice ? $numeral(accessory.msrpPrice).format('$0,0') : 'N/A' }}</span></p>
                </div>
                <div class="my-2" v-else>
                  <p><span class="is-size-7 is-uppercase">MSRP:</span> <span class="has-text-weight-semibold">{{ accessory.msrpPrice ? $numeral(accessory.msrpPrice).format('$0,0') : 'N/A' }}</span></p>
                </div>
              </template>
            </div>
            <div class="accessory-item-actions">
              <div>
                <label class="label">Quantity</label>
                <b-field style="width: 125px; margin-bottom: 0">
                  <b-numberinput
                    size="is-small"
                    max="999"
                    min="1"
                    v-model="accessoryCart[accessory.kpc]"
                  ></b-numberinput>
                </b-field>
              </div>
              <b-button
                rounded
                size="is-small"
                type="is-dark"
                @click="addAccessoryToCart(accessory, accessoryCart[accessory.kpc])"
                >ADD</b-button
              >
            </div>
          </div>
        </div>
        <div class="p-4 content">
          <p class="has-text-weight-semibold">The following accessories are available from our partners. Please contact them directly.</p>
          <ul>
              <li>De-icing solutions will be provided by Walton De-Ice (<a href="http://www.de-ice.com" target="_blank">http://www.de-ice.com</a>)</li>
              <li>The Maritime Pedestal Mount will be provided by Seaview Global (<a href="https://www.seaviewglobal.com" target="_blank">https://www.seaviewglobal.com</a>)</li>
            </ul>
        </div>
      </div>
    </main>
    <footer class="m-4 p-3 is-flex is-justify-content-flex-end">
      <b-button
          rounded
          size="is-small"
          type="is-dark"
          @click="() => { $store.commit('configurator/setActivePage', 2); $kya.event('configurator', 'backToCartFromAccessoryPage', 'Returned to cart from accessory page.', am); }"
          >BACK TO CART</b-button
        >
    </footer>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import { 
  computed, 
  reactive, 
  ref, 
  getCurrentInstance 
} from 'vue';
import ConfiguratorAccessoryDetailModal from './modals/ConfiguratorAccessoryDetailModal.vue';

export default {
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const am = computed(() => root.$store.getters['configurator/analyticsMetadata']);
    const accessories = computed(() => root.$store.getters['configurator/accessories']);
    const wholesale = computed(() => root.$store.state.configurator.wholesale);
    const showPrices = computed(() => root.$store.state.configurator.showPrices);
    const allProducts = computed(() => root.$store.getters['configurator/allProducts']);
    const assetCdnUrl = computed(() => root.$store.state.appConfig.assetCdnUrl);

    // Filters
    const productFamilyFilters = ref([]);
    const audienceFilters = ref([]);
    const availabilityFilters = ref([]);

    // sort alphabetically based on productFamily
    // eslint-disable-next-line no-unused-vars
    const sortAccessories = (a, b) => {
      if (a.productFamily < b.productFamily) {
        return -1;
      }
      if (a.productFamily > b.productFamily) {
        return 1;
      }
      return 0;
    };

    // sort alphabetically based on description
    const sortAccessoriesByDesc = (a, b) => {
      if (a.description < b.description) {
        return -1;
      }
      if (a.description > b.description) {
        return 1;
      }
      return 0;
    };

    const filteredAccessories = computed(() => {
      let returnArray = [...accessories.value];
 
      if (productFamilyFilters.value.length) {
        returnArray = returnArray.filter(acc => productFamilyFilters.value.includes(acc.productFamily));
      }

      if (audienceFilters.value.length) {
        if (audienceFilters.value.includes('comm')) returnArray = returnArray.filter(acc => acc.comm);
        if (audienceFilters.value.includes('mil')) returnArray = returnArray.filter(acc => acc.mil);
      }

      if (availabilityFilters.value.length) {
        returnArray = returnArray.filter(acc => availabilityFilters.value.includes(acc.unavailable))
      }
      // sort by desc alphabetical
      returnArray.sort(sortAccessoriesByDesc);

      return returnArray;
    });
    const mouseOverVisibleOn = ref(null);
    const toggleFilter = (key, value) => {
      // if unavailable All is selected, remove all unavailable filters and exit early
      switch (key) {
        case 'productFamily':
          if (productFamilyFilters.value.includes(value)) productFamilyFilters.value = productFamilyFilters.value.filter(v => v !== value)
          else productFamilyFilters.value.push(value);
          break;
        case 'comm':
          // want to see commercial
          if (audienceFilters.value.includes('comm')) audienceFilters.value = audienceFilters.value.filter(v => v !== 'comm');
          else audienceFilters.value.push('comm');
          break;
        case 'mil':
          if (audienceFilters.value.includes('mil')) audienceFilters.value = audienceFilters.value.filter(v => v !== 'mil');
          else audienceFilters.value.push('mil');
          break;
        case 'unavailable':
          if (availabilityFilters.value.includes(value)) availabilityFilters.value = availabilityFilters.value.filter(v => v !== value)
          else availabilityFilters.value.push(value);
          break;
        default:
          break;
      }
    }
    
    // #region Set up the Accessory Cart
    const accessoryDictionary = {}
    accessories.value.forEach(a => { accessoryDictionary[a.kpc] = 1; });
    const accessoryCart = reactive({ ...accessoryDictionary });
    // #endregion

    const productIsUnavailable = (kpc) => {
      const unavailableKPCs = allProducts.value.filter(p => p.unavailable).map(p => p.kpc);
      return unavailableKPCs.includes(kpc);
    }

    const addAccessoryToCart = (accessory, quantity) => {
      const cartAccessory = {
        quantity,
        kpc: accessory.kpc,
        id: uuidv4(),
        item: {
          name: accessory.name
        }
      }
      root.$store.commit('configurator/addToCart', cartAccessory);
      root.$buefy.snackbar.open({
        message: `<strong class="has-text-weight-semibold">(${quantity})</strong> <strong>${accessory.name}</strong> was added to your shopping cart.`,
        type: 'is-success',
        duration: 3500,
        position: 'is-bottom',
        actionText: 'OK',
        indefinite: false
      });

      accessoryCart[accessory.kpc] = 1;
      root.$kya.event('configurator', 'addAccessoryToCart', 'Added an accessory to cart.', { ...am.value, accessory });
    }

    const openProductDetail = (product) => {
      root.$buefy.modal.open({
        component: ConfiguratorAccessoryDetailModal,
        trapFocus: true,
        props: {
          product,
          showPrices,
          wholesale,
          assetCdnUrl
        },
        events: {
          addToCart: (count) => {
            if (count) {
              addAccessoryToCart(product, count.value); // count is a ref()
              root.$kya.event('configurator', 'addAccessoryToCart', 'Added an accessory to cart.', { ...am.value, product });
            }
          }
        }
      });
      root.$kya.event('configurator', 'openDetailModalOnAccessoryPage', 'Opened the detail modal on accessory page.', { ...am.value, ...product });
    }

    const filterActive = (filter) => {
      const key = Object.keys(filter)[0];
      const value = Object.values(filter)[0];

      switch (key) {
        case 'productFamily':
          return productFamilyFilters.value.includes(value);
        case 'comm':
        case 'mil':
          return audienceFilters.value.includes(key);
        case 'unavailable':
          return availabilityFilters.value.includes(value);
        default:
          return false;
      }
    }

    return {
      filteredAccessories,
      wholesale,
      accessoryCart,
      addAccessoryToCart,
      showPrices,
      productIsUnavailable,
      am,
      openProductDetail,
      mouseOverVisibleOn,
      filterActive,
      productFamilyFilters,
      audienceFilters,
      availabilityFilters,
      toggleFilter,
      assetCdnUrl
    }
  }  
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-configurator-accessories {
  overflow-y: auto;
  height: 100%;

  .accessory-selector-wrapper {
    display: grid;
    grid-template-columns: minmax(250px, 15%) 1fr;

    .accessory-selector-items {
      display: grid;
      grid-gap: 1rem;
      grid-template-columns: repeat(auto-fill, minmax(250px, auto));
      grid-template-rows: repeat(auto-fill);
    }
  }

  .accessory-item {
    background: white;
    display: grid;
    grid-template-rows: 200px 1fr auto;
    gap: 0.5rem;

    .accessory-item-image {
      position: relative;
      overflow: hidden;

      figure.b-image-wrapper.image {
        z-index: 8;
        height: 100%;
      }

      .accessory-item-more-info {
        position: absolute;
        bottom: 0.25rem;
        right: 0.25rem;
        z-index: 9;
      }
    }

    .accessory-item-actions {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }
  }

  .accessory-content {
    .accessory-quantity-select {
      display: grid;
      grid-template-columns: 150px 1fr 200px;
      border-bottom: 1px solid $grey-lighter;
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      align-items: center;
    }
  }
}
</style>
